
import React, { createContext, useContext, useState } from 'react';
import { Species } from '../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Species/PathItems';
import { useToast } from './ToastProvider';
import { Result } from '@peercolab/engine';
import { Session } from '../peer-colab-model/Session';
import { SpeciesManagement } from '../peer-colab-model/PetKey/BackofficeFE/Client/PathItems';

type SpeciesContextType = {
  species: Species[];
  loadSpecies: (id: string) => Promise<Result<Species>>
};

const SpeciesContext = createContext<SpeciesContextType | undefined>(undefined);

export const SpeciesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { onError } = useToast();
  const [species, setSpecies] = useState<Species[]>([]);

  const loadSpecies = async (id: string): Promise<Result<Species>> => {
    return onError((await Session.getSpeciesClient(id).request(SpeciesManagement.getSpecies()))
      .maybePassThroughOk((match) => {
        setSpecies(prev => {
          const idx = prev.findIndex(s => s.id === match.id);
          if (idx >= 0) {
            // Update existing species
            return prev.map(s => s.id === match.id ? match : s);
          } else {
            // Add new species
            return [...prev, match];
          }
        });
      }));
  }

  return (
    <SpeciesContext.Provider value={{ species, loadSpecies }}>
      {children}
    </SpeciesContext.Provider>
  );
};

export function useSpecies() {
  const ctx = useContext(SpeciesContext);
  if (!ctx) throw new Error('useSpecies must be used within a SpeciesProvider');
  return ctx;
}
